export default {
  boxLength: 400,
  boxHeight: 450,
  boxWidth: 200,
};
